export default {
	tenantId: "cpicLife_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "cpiclife--uat"
	}
}
